import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import AdminDashboard from "./AdminDashboard";
import ProPage from "./ProPage";
import AnnouncementBanner from "./AnnouncementBanner";
import PushPrompt from "./PushPrompt";
import VerifyEmail from "./VerifyEmail";
import VerifyBanner from "./VerifyBanner";
import "./index.css";

function Root() {
  const path = window.location.pathname;

  if (path === "/verify") {
    return <VerifyEmail />;
  }

  let page;
  if (path === "/admin") {
    page = <AdminDashboard />;
  } else if (path === "/pro" ||
      path === "/pro/success" ||
      path === "/pro/cancel") {
    page = <ProPage />;
  } else {
    page = <App />;
  }
  // Banners + push prompt on all visitor-facing pages (not the admin console)
  const isAdmin = path === "/admin";
  return (
    <>
      {!isAdmin && <AnnouncementBanner />}
      {!isAdmin && <VerifyBanner />}
      {page}
      {!isAdmin && <PushPrompt />}
    </>
  );
}

const root = ReactDOM.createRoot(
  document.getElementById("root")
);
root.render(<Root />);
